import React from 'react';
import styled from 'styled-components';
import BurgerButtonClose from './BurgerButtonClose';
import { COLORS, device } from '../../constants';
import { HeaderInnoLogo } from '../../assets/svg';
import { Logo } from '../Header/Header';

interface Props {
  children: React.ReactNode;
  isActive: boolean;
  onClick: () => void;
}

const BurgerMenu = ({ children, isActive, onClick }: Props) => {
  return (
    <HamburgerContainer $active={isActive}>
      <MenuHeader>
        <Logo>
          <HeaderInnoLogo />
        </Logo>
        <BurgerButtonClose onClick={onClick} />
      </MenuHeader>
      <div>{children}</div>
    </HamburgerContainer>
  );
};

const HamburgerContainer = styled.div<{ $active: boolean }>`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  display: none;
  align-items: flex-start;
  padding: 20px;
  flex-direction: column;
  max-width: 380px;
  box-sizing: border-box;
  width: 100%;
  gap: 10px;
  z-index: 20;
  transition-duration: 0.3s;
  transition-timing-function: ease-in-out;
  transition-property: opacity, visibility, transform;
  transform: ${({ $active }) =>
    $active ? 'translateX(0)' : 'translateX(-100%)'};
  background: ${COLORS.WHITE};
  @media ${device.md} {
    display: flex;
  }
`;

const MenuHeader = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-start;
  justify-content: space-between;
`;

export default BurgerMenu;
